import React, { useState, useEffect } from "react";
import { history } from "../../../history/history";
import { checkadminlink } from "../../../util/util";
import { sidebarList } from "../../../../config/sideBarList";
import { sidebarForRole } from "../../../../config/sidebarForRole";

//Return the sidebar route for admin
const SideBar = (props) => {
  let role = localStorage.getItem("adminRole");
  let menus = [],
    listMenu = [];
      if (sidebarForRole[role]) {
    if (sidebarForRole[role] && sidebarForRole[role].routes == "all") {
      listMenu = Object.keys(sidebarList);
    } else if (sidebarForRole[role]) {
      listMenu = sidebarForRole[role].routes;
    }
    for (const menuslist of listMenu) {
      menus.push(sidebarList[menuslist]);
    }
  }
  const [Menu, setMenu] = useState(menus);

  useEffect(() => {
    var parent, child;
    for (const [menuIndex, Menus] of Menu.entries()) {
      for (const [subMenuIndex, subMenus] of Menus.submenu.entries()) {
        if (subMenus.menuLink == window.location.pathname) {
          parent = menuIndex;
          child = subMenuIndex;
        }else{
          let mainMenu = window.location.pathname.split("/")
          let currentMainMenu = subMenus.menuLink.split("/")
          if(mainMenu[2] == currentMainMenu[2]){
            parent = menuIndex;
            child = subMenuIndex;
          }
        }
      }
    }
    if (parent == undefined || child == undefined) {
      window.location = sidebarForRole[localStorage.getItem("adminRole")].default;
    } else {
      checkadminlink(props, parent, child);
    }
  }, []);

  const [openClass, handleOpenClass] = useState("");

  const handleClick = (permission, i, e) => {
    console.log(localStorage.getItem("adminRole"));
    console.log(permission);
    const adminRole = localStorage.getItem("adminRole");
    e.preventDefault();
    const t = e.target;
    let d = document;
    var ul = d.querySelectorAll("ul");
    var li = d.querySelectorAll(".manageSystem-list");
    var liparent = d.querySelectorAll(".side-menuInner");
    var parentcl = document.querySelectorAll(".side-menuInner");
    localStorage.setItem("parent", i);
    for (let i = 0; i < li.length; i++) {
      if (i != localStorage.getItem("parent")) {
        li[i].classList.remove("open");
        parentcl[Number(i)].classList.remove("active_manager_user");
      }
    }
    parentcl[Number(i)].classList.toggle("active_manager_user");
    if (t.nextElementSibling) {
      t.nextElementSibling.classList.toggle("open");
      handleOpenClass(t.nextElementSibling.classList);
    }
  };

  const handleSubMenu = (link, i, e) => {
    localStorage.removeItem("openClass");
    e.preventDefault();
    const t = e.target;
    let d = document;
    var li = d.querySelectorAll(".manageSystem-list");
    var child = d.querySelectorAll(".submenu_main");
    for (let i = 0; i < li.length; i++) {
      li[i].classList.remove("open");
    }
    //  child[i].classList.add("activedrawer");
    li[Number(localStorage.getItem("parent"))].classList.add("open");
    localStorage.setItem("child", i);
    history.push(link);
  };

  return (
    <div className="side-menu master-menu">
      <ul className="side-menuList">
        {Menu.map((m, i) => (
          <li
            className="side_bar_menu_cust side-menuInner manage-user "
            key={i}
            onClick={handleClick.bind(this, m.accessTo, i)}
          >
            <a>
              <span className="menu-icon">
                <img src={m.icon} />
              </span>
              <span className="menu-title">{m.menuName}</span>
            </a>
            <div className="manageSystem-list">
              <ul className="manageSystem-list-inner">
                {m.submenu.map((s, j) => (
                  <li key={j} className="submenu_main">
                    <a onClick={handleSubMenu.bind(this, s.menuLink, j)}>
                      <span className="menu-icon submenu-icon">
                        <img src={s.icon} />
                      </span>
                      <span className="menu-title">{s.menuName}</span>
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          </li>
        ))}
      </ul>
    </div>
  );
};
export default SideBar;



// WEBPACK FOOTER //
// ./web/components/admin/common/sideBar.js